<template>
  <Popover :title="title" ref="popover" @show="onPopoverShow" @hide="onPopoverHide">
    <el-radio-group v-model="innerRadio" class="edit-budget">
      <el-radio :label="0" :disabled="disabledLongTerm"> 长期投放 </el-radio>
      <el-radio :label="1">
        <el-date-picker
          v-model="innerValue"
          :picker-options="{ disabledDate }"
          :clearable="false"
          :disabled="innerRadio === 0"
          style="width: 190px"
          type="date"
          placeholder="选择结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-radio>
    </el-radio-group>

    <div style="display: inline-block">
      <el-button type="text" @click="confirm">&ensp;保存</el-button>
    </div>

    <div slot="ref">
      <slot></slot>
    </div>
  </Popover>
</template>

<script>
import Popover from '@/components/popover/index.vue'
import { truncatedNumber } from '@/common/js/utils.js'

export default {
  components: { Popover },
  props: {
    value: [String],
    radio: Number,
    title: String,
    disabledDate: {
      type: Function
    },
    disabledLongTerm: Boolean
  },
  data() {
    return {
      innerValue: '',
      innerRadio: 0
    }
  },
  methods: {
    confirm() {
      this.$emit('update:radio', this.innerRadio)
      this.$emit('input', this.innerValue)
      this.$refs.popover.close()
    },
    onPopoverShow() {
      this.innerValue = this.value
      this.innerRadio = this.radio
    },
    onPopoverHide() {
      this.innerValue = ''
      this.innerRadio = 0
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
